module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-accordion p-component"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c906b3c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/accordion/Accordion.vue
// module id = 2404
// module chunks = 0